export interface UserInput {
  user_name: string; // Name of the user
  email: string;     // Email of the user
  role: string;      // Role of the user (e.g., Administrator)
  status: boolean;   // User's active or inactive status
  password?: string; // Optional password field for new users
}
export interface UserStatusInput {
  id: string,
  status: number
}

export interface UserRoleInput {
  id: string,
  role: string
}

export interface ForgotDataTransfer {
  type: number,
  email: string
}
export interface ForgotTokenTransfer {
  token: string,
  email: string
}
export interface otpInput {
  address_id: number,
}
export interface otpVerifyInput {
  address_id: string,
  code:string
}

export interface UserAddInputModel {
  id?:string;
  account_type: string;  // two types only
  full_name?: string;
  username?: string;  // required only if account_type is staff
  email?: string;
  role?: string;      // required only if account_type is staff
  password?: string;
}


export interface UserRole {
      new_role:string
    }